import { render, staticRenderFns } from "./VueBootstrapTypeahead.vue?vue&type=template&id=4f5f24ee&scoped=true&"
import script from "./VueBootstrapTypeahead.vue?vue&type=script&lang=js&"
export * from "./VueBootstrapTypeahead.vue?vue&type=script&lang=js&"
import style0 from "./VueBootstrapTypeahead.vue?vue&type=style&index=0&id=4f5f24ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f24ee",
  null
  
)

export default component.exports